import { render, staticRenderFns } from "./createCollectionProfile.vue?vue&type=template&id=3152b9bc"
import script from "./createCollectionProfile.vue?vue&type=script&lang=js"
export * from "./createCollectionProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports